"use client";

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@aio/platform-ui";
import { Languages } from "lucide-react";
import { useLocale, type SupportedLocale } from "./provider";

const LABELS: Record<SupportedLocale, string> = {
  "sr-Latn": "Srpski (Latinica)",
  "sr-Cyrl": "Српски (Ћирилица)",
  en: "English",
};

const ORDER: SupportedLocale[] = ["sr-Latn", "sr-Cyrl", "en"];

export function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" aria-label="Change language">
          <Languages className="size-4" /> {LABELS[locale]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {ORDER.map((l) => (
          <DropdownMenuItem key={l} onSelect={() => setLocale(l)}>
            {LABELS[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
